import { computeAdditionalFees } from './additionalFees'
import { computeFeeInfo } from './feeInfo'
import { computeOtherFeeBeforeTimeAndTax } from './otherFee'

function currentParcelsFee ({ shippingRatesInfo, seaParcelsFeeInfo, feeInfo }) {
  if (shippingRatesInfo.transport === 'sea') return seaParcelsFeeInfo.parcelsFee
  return feeInfo.discountParcelsFeeFormulas
    ? feeInfo.discountParcelsFee
    : feeInfo.parcelsFee
}

export function buildFeeBaseSnapshot (data, policy = {}) {
  const feeInfo = computeFeeInfo(data.feeInfoContext)
  const parcelsFee = currentParcelsFee({
    shippingRatesInfo: data.shippingRatesInfo,
    seaParcelsFeeInfo: data.seaParcelsFeeInfo,
    feeInfo,
  })
  const additionalFees = computeAdditionalFees({
    ...data.additionalFeeContext,
    parcelsFee,
  }, {
    apartFeePerParcel: policy.apartFeePerParcel,
  })
  const amountContext = {
    parcelsFee,
    jyoBusyFee: data.jyoBusyFee,
    jyoOvldFee: data.jyoOvldFee,
    jyHctCaiFee: data.jyHctCaiFee,
    hctPalletFee: data.hctPalletFee,
    ...additionalFees,
    otherFeesOtherFee: data.otherFees.otherFee,
    sedeFee: data.sedeFee,
    localFee: data.localFee,
    vanFee: data.vanFee,
    isTimeIns: data.additionalFeeContext.form.jyoExtraInfo.isTimeIns === '1',
    finalSrParcelsFeeFormulas: data.finalSrParcelsFeeFormulas,
    isAllIncTax: data.isAllIncTax,
    cneeAddressDiscount: data.cneeAddressDiscount,
  }

  return {
    feeInfo,
    shippingRatesInfo: data.shippingRatesInfo,
    hasShippingRate: Boolean(data.hasShippingRate),
    prepareModel: data.prepareModel,
    tradevanAddr: data.tradevanAddr,
    estimateWeight: data.estimateWeight,
    currency: data.currency,
    parcelsFee,
    additionalFees,
    finalSrParcelsFeeFormulas: data.finalSrParcelsFeeFormulas,
    cneeAddressDiscount: data.cneeAddressDiscount,
    otherFees: data.otherFees,
    amountContext,
    otherFeeBeforeTimeAndTax: computeOtherFeeBeforeTimeAndTax(amountContext),
  }
}

export default buildFeeBaseSnapshot
